/**
 * Landing page data composable
 * Provides all static data for the landing page sections
 */

export interface Testimonial {
  content: string
  name: string
  position: string
}

export interface Feature {
  name: string
  icon: string
}

export interface PricingRow {
  icon: string
  type: string | null
  otherPlatform: string
  rintisanBilling: string
  defaultBilling: string
  img1?: string
  img2?: string
  classimg1?: string
}

export interface FAQ {
  question: string
  answer: string
}

export function useLandingData() {
  const testimonials: Testimonial[] = [
    {
      content: 'Pernah kendala cashflow karena customer telat membayar. Untung ada Rintisan Billing jadi bisa bayar supplier pakai cicilan',
      name: 'Febiany Giyanti',
      position: 'Owner Gerry Production',
    },
    {
      content: 'Buat pemilik olshop, app ini udah membantu banget buat mengurangi beban bisnis saya kalau ada pembayaran mendadak',
      name: 'Audrey Salim',
      position: 'Owner Baby Shop',
    },
    {
      content: 'Selain buat bayar kebutuhan bisnis dan nagih klien, kadang kami bisa gunakan juga untuk membayar gaji karyawan',
      name: 'Abraham Kurnia',
      position: 'Franchisee JNE Cargo',
    },
  ]

  const features: Feature[] = [
    {
      name: 'Laporan Real-time dalam satu Tampilan terpadu',
      icon: '/images/icons/f-1.png',
    },
    {
      name: 'Pilihan Pembayaran Multichannel',
      icon: '/images/icons/f-2.png',
    },
    {
      name: 'Pencairan langsung ke seluruh bank',
      icon: '/images/icons/f-3.png',
    },
    {
      name: 'Otomisasi sistem pembayaran Anda dengan integrasi',
      icon: '/images/icons/f-4.png',
    },
    {
      name: 'Layanan keuangan tambahan oleh partner Rintisan',
      icon: '/images/icons/f-5.png',
    },
  ]

  const pricingData: PricingRow[] = [
    {
      icon: '/images/primary/BLIBLI2.png',
      type: 'Credit Card',
      otherPlatform: '1.9%',
      rintisanBilling: '1.65%',
      defaultBilling: '1.75%',
      img1: '/images/icons/blu.png',
      classimg1: 'mt-1 -ml-2',
    },
    {
      icon: '/images/primary/BLIBLI2.png',
      type: 'Cicilan, Non Credit Card, & Virtual Akun',
      otherPlatform: '-',
      rintisanBilling: '0.375%',
      defaultBilling: '0.5%',
    },
    {
      icon: '/images/primary/BLIBLI2.png',
      type: 'Paylater',
      otherPlatform: '-',
      rintisanBilling: '2.5%',
      defaultBilling: '3.5%',
      img1: '/images/icons/home-credit.png',
      img2: '/images/icons/kredivo.png',
    },
    {
      icon: '/images/primary/tokpedBigLogo.png',
      type: 'Credit Card',
      otherPlatform: '1.9%',
      rintisanBilling: '1.55%',
      defaultBilling: '1.65%',
    },
    {
      icon: '/images/primary/tokpedBigLogo.png',
      type: 'Cicilan, Non Credit Card, & Virtual Akun',
      otherPlatform: '1.9%',
      rintisanBilling: '0.375%',
      defaultBilling: '0.5%',
    },
    {
      icon: '/images/primary/Shopee.png',
      type: 'SPaylater',
      otherPlatform: '3%',
      rintisanBilling: '2%',
      defaultBilling: '3%',
    },
    {
      icon: '/images/primary/QRISV3.png',
      type: null,
      otherPlatform: '0.7%',
      rintisanBilling: '0.5%',
      defaultBilling: '0.7%',
    },
    {
      icon: '/images/primary/ccFull.png',
      type: 'Online Credit Card (F&B)',
      otherPlatform: '2%',
      rintisanBilling: '1.8%',
      defaultBilling: '2%',
    },
  ]

  const faqs: FAQ[] = [
    {
      question: 'Di mana saya bisa mendapatkan aplikasi Rintisan Billing?',
      answer: '<p>Kabar gembira untuk Anda! Anda bisa langsung "Pakai Gratis Sekarang" Rintisan Billing. Cukup klik tombol DAFTAR, dan ya! Anda sudah siap memulai perjalanan invoicing yang #MakinRingan. Tidak perlu repot-repot ke mana-mana, cukup dari perangkat seperti Smartphone atau Laptop kesayangan Anda!</p>',
    },
    {
      question: 'Apa syarat yang dibutuhkan untuk menjadi bagian dari Rintisan Billing?',
      answer: '<p>Syaratnya sangat Mudah dan Sederhana! Yang Anda butuhkan hanyalah semangat untuk membuat bisnis Anda #MakinRingan. Rintisan Billing terbuka untuk semua kalangan pebisnis, dari yang baru merintis sampai yang sudah berpengalaman. Jadi, siapkan semangat Anda, dan mari bergabung dengan Kami!</p>',
    },
    {
      question: 'Fitur dan Layanan Rintisan menawarkan 3 layanan utama apa saja?',
      answer: `<ol class="list-decimal list-inside space-y-4">
        <li class="font-medium">Smart Payment
          <p class="ml-6 mt-1 font-normal">Sistem pembayaran yang memudahkan proses penerimaan dan pembayaran dengan berbagai metode seperti Direct CC, Virtual Account, QRIS, dan integrasi dengan Marketplace seperti Blibli.</p>
        </li>
        <li class="font-medium">Business Management
          <p class="ml-6 mt-1 font-normal">Fitur lengkap untuk mengelola bisnis termasuk dashboard analitik, manajemen stok, laporan keuangan dengan <a href="https://business.rintisan.co.id" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline">https://business.rintisan.co.id</a>.</p>
        </li>
        <li class="font-medium">Digital Invoicing
          <p class="ml-6 mt-1 font-normal">Platform <a href="https://billing.rintisan.co.id" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline">https://billing.rintisan.co.id</a> Pembuatan dan pengiriman invoice digital yang dapat dilakukan dalam hitungan detik. Dilengkapi dengan template professional dan sistem pengingat otomatis melalui WhatsApp atau email.</p>
        </li>
      </ol>`,
    },
    {
      question: 'Apakah Membayar Invoice Rintisan Billing dikenakan Biaya?',
      answer: '<p>Ya, ada biaya layanan yang dikenakan namun sangat kompetitif. Biaya ini mencakup seluruh fitur keamanan dan kenyamanan dalam bertransaksi. Biaya layanan dapat dibebankan kepada merchant atau customer sesuai kesepakatan. Besaran biaya ini sebanding dengan kemudahan dan efisiensi yang didapatkan dalam proses transaksi bisnis.</p>',
    },
    {
      question: 'Kapan Invoice Rintisan Billing bisa dibayar?',
      answer: '<p>Pembayaran dapat dilakukan segera setelah menerima notifikasi invoice melalui WhatsApp atau email. Customer dapat mengklik link pembayaran yang dikirimkan dan akan diarahkan ke halaman pembayaran Rintisan Billing yang menampilkan detail invoice secara lengkap.</p>',
    },
    {
      question: 'Keuntungan Menggunakan Rintisan Billing?',
      answer: `<p>Rintisan Billing menghadirkan berbagai keuntungan yang memudahkan proses transaksi bisnis Anda. Platform <a href="https://billing.rintisan.co.id" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:underline">https://billing.rintisan.co.id</a> dapat diakses 24/7 dari mana saja, sehingga Anda tidak perlu khawatir tentang batasan waktu atau lokasi dalam mengelola pembayaran. Sistem keamanan yang terenkripsi menjamin setiap transaksi berjalan dengan aman dan terpercaya, ditambah dengan proses pembayaran yang cepat dan efisien. Anda bisa memilih berbagai metode pembayaran sesuai kebutuhan, mulai dari Direct CC, Virtual Account, QRIS hingga marketplace seperti Blibli.</p>
      <p class="mt-4">Yang membuat Rintisan Billing semakin unggul adalah dashboard bisnis yang lengkap dan informatif, memungkinkan Anda memantau performa bisnis secara real-time. Tidak perlu menunggu lama untuk menerima dana, karena sistem pencairan H+1 memastikan cashflow bisnis Anda tetap lancar. Rintisan Billing hadir sebagai solusi lengkap untuk kebutuhan pembayaran digital bisnis franchise, waralaba, kemitraan, dan UMKM Anda.</p>`,
    },
    {
      question: 'Bagaimana cara menghapus akun Rintisan Billing?',
      answer: '<p>Untuk menghapus akun Rintisan Billing, silakan hubungi tim support kami melalui email di <strong>support@rintisan.co.id</strong>. Permintaan Anda akan diproses sesuai prosedur keamanan yang berlaku.</p>',
    },
    {
      question: 'Bagaimana cara menghubungi Rintisan Billing jika pertanyaan saya tidak terjawab di sini?',
      answer: `<p>Jangan khawatir, tim support Rintisan Billing siap membantu Anda! Anda bisa langsung menghubungi kami di:</p>
      <p class="mt-4"><strong>Email: support@rintisan.co.id</strong><br/>
      <strong>Jam kerja: Senin-Jumat, 09:00-17:00</strong></p>
      <p class="mt-4">Atau jika Anda sedang berada di Jakarta, Anda bisa mengunjungi kantor Kami di Holland Village Office Tower lantai 26. Kami jamin, pertanyaan Anda akan dijawab dengan ramah!</p>`,
    },
  ]

  const appStoreLinks = {
    ios: 'https://apps.apple.com/id/app/id6745549559',
    android: 'https://play.google.com/store/apps/details?id=id.co.rintisan.billing&hl=id',
  }

  return {
    testimonials,
    features,
    pricingData,
    faqs,
    appStoreLinks,
  }
}
